"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import compose from "koa-compose";
import combineParamsMiddleware from "./middleware/combineParams";
import optionsParserMiddleware from "./middleware/optionsParser";
export default class Http {
  constructor(parent, fetch2) {
    this.get = this.wrap("GET");
    this.put = this.wrap("PUT");
    this.post = this.wrap("POST");
    this.patch = this.wrap("PATCH");
    this.delete = this.wrap("DELETE");
    this._middleware = [];
    if (parent instanceof Http) {
      this.parent = parent;
    } else if (fetch2 === void 0 && typeof parent === "function") {
      this.fetch = parent;
    }
    if (fetch2) {
      this.fetch = fetch2;
    }
  }
  get middleware() {
    if (this.parent) {
      return [...this.parent.middleware, ...this._middleware];
    } else {
      return [...this._middleware];
    }
  }
  useMiddleware(callback) {
    this._middleware.push(callback);
  }
  child(fetch2) {
    return new Http(this, fetch2 || this.fetch);
  }
  request(url, options) {
    return __async(this, null, function* () {
      if (typeof url === "string") {
        if (options) {
          options.url = url;
        } else {
          options = { url };
        }
      } else {
        options = url;
      }
      url = options.url || "";
      options.headers = options.headers || {};
      const m = [
        ...this.middleware,
        optionsParserMiddleware,
        combineParamsMiddleware,
        (ctx2, next) => __async(this, null, function* () {
          const { req } = ctx2;
          const res = yield (this.fetch || fetch)(ctx2.url, req);
          ctx2.res = res;
          return yield next();
        })
      ];
      const middlewareFn = compose(m);
      const ctx = {
        url,
        req: options,
        res: {}
      };
      const result = yield middlewareFn(ctx);
      return result === void 0 ? ctx.res : result;
    });
  }
  wrap(method) {
    return (url, options = {}) => {
      if (typeof url === "string") {
        options.url = url;
      } else {
        options = url;
      }
      options.method = method;
      return this.request(options);
    };
  }
}
//# sourceMappingURL=Http.js.map
